import { useEffect } from 'react';
import triggerGoogleTagManagerCustomEvent from '../../common/utils/triggerGoogleTagManagerCustomEvent';
import GtmEvents from '../constants/gtmEvents';
import findAssociatedLabel from '../utils/findAssociatedLabel';

function useGtmValidationErrorTracking() {
  useEffect(() => {
    const handleSubmit = (e: Event) => {
      if (!(e.target instanceof HTMLFormElement)) {
        return;
      }

      const form = e.target;

      // Delay to allow Formik validation to run and errors to render
      requestAnimationFrame(() => {
        // Find all elements with errors (Formik sets aria-invalid="true")
        const fields = form.querySelectorAll<HTMLElement>('[aria-invalid="true"]');

        fields.forEach((field) => {
          // Check for error element using aria-errormessage or aria-describedby (Formik pattern)
          const errorId =
            field.getAttribute('aria-errormessage') || field.getAttribute('aria-describedby');
          let errorElement = errorId ? document.getElementById(errorId) : null;

          // Fallback to other common error patterns
          if (!errorElement) {
            errorElement =
              field.parentElement?.querySelector('[class*="error"]') ||
              field.parentElement?.querySelector('[role="alert"]') ||
              document.querySelector(`[id="${field.id}-error"]`);
          }

          if (errorElement && errorElement.textContent?.trim()) {
            const label = findAssociatedLabel(field);
            triggerGoogleTagManagerCustomEvent(GtmEvents.VALIDATION_ERROR, {
              label,
              message: errorElement.textContent.trim(),
            });
          }
        });
      });
    };

    document.addEventListener('submit', handleSubmit, { capture: true });
    return () => document.removeEventListener('submit', handleSubmit, { capture: true });
  }, []);
}

export default useGtmValidationErrorTracking;
